module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAGQCAYAAABvWArbAAAANUlEQVQ4je3LMQoAIBADwb38/6t5wFXaWAiCtUiaYZvF9hBACOFbuntVVe11B0CSjjeE8BwThQIJ8dhEl0YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/ui/images/ui-bg_glass_75_e6e6e6_1x400.png
// module id = 230
// module chunks = 0